// modules
import { createAction } from 'redux-actions'

// actions
export const setCaregiverAssignedPatients = createAction(
  'SET_CAREGIVER_ASSIGNED_PATIENTS'
)
export const setCaregiverSearchedPatients = createAction(
  'SET_CAREGIVER_SEARCHED_PATIENTS'
)

export const resetCaregiverAccessRestrictions = createAction(
  'RESET_CAREGIVER_ACCESS_RESTRICTIONS'
)
